import { render, staticRenderFns } from "./ParticipantsPanel.vue?vue&type=template&id=5406b500"
import script from "./ParticipantsPanel.vue?vue&type=script&lang=js"
export * from "./ParticipantsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports